'use strict';

/**
 * Detects if the view is being rendered in mobile.
 * @param userAgent string
 * @returns {boolean} true if the view is loaded in mobile/tablet.
 */

function isDevice(userAgent) {
    if (userAgent.match(/Android|webOS|iPhone|iPad|iPod|bada|Symbian|Palm|CriOS|BlackBerry|IEMobile|WindowsMobile|Opera Mini/i)) {
        return true;
    }

    return false;
}

/**
 * Method to detect if the merchant page is in web view
 * @param userAgent string
 * @returns {boolean} True if web view
 */
function isWebView(userAgent) {
    return (/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i).test(userAgent) || 
        (/\bwv\b/).test(userAgent) || 
    (/Android.*Version\/(\d)\.(\d)/i).test(userAgent);
}

function getAgent(agent) {
    var ua = agent || navigator.userAgent, tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = (/\brv[ :]+(\d+)/g).exec(ua) || [];
        return ['IE', tem[1] || ''];
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR\/(\d+)/);
        if (tem !== null) {
            return ['Opera', tem[1]];
        }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+(\.\d{1,2}))/i)) !== null) {
        M.splice(1, 1, tem[1]);
    }
    return M;
}

module.exports = {
    getAgent: getAgent,
    isDevice: isDevice,
    isWebView: isWebView
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/device.js
 ** module id = 10
 ** module chunks = 0
 **/